import { render, staticRenderFns } from "./InsFooterLayout.vue?vue&type=template&id=b54cae86&scoped=true"
import script from "./InsFooterLayout.vue?vue&type=script&lang=ts"
export * from "./InsFooterLayout.vue?vue&type=script&lang=ts"
import style0 from "./InsFooterLayout.vue?vue&type=style&index=0&id=b54cae86&prod&lang=less"
import style1 from "./InsFooterLayout.vue?vue&type=style&index=1&id=b54cae86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54cae86",
  null
  
)

export default component.exports